import {
  CHANGE_ACTIVE_ITEM_HOME,
  CHANGE_ACTIVE_ITEM_LIVELIST,
  CHANGE_ACTIVE_ITEM_LOG,
  CHANGE_ACTIVE_ITEM_CONFIG,
  CHANGE_ACTIVE_ITEM_INVENTORY,
  CHANGE_ACTIVE_ITEM_PORTS,
  CHANGE_ACTIVE_ITEM_MEDIA,
  CHANGE_ACTIVE_ITEM_INTERFACE,
  CHANGE_ACTIVE_ITEM_NETWORK,
  CHANGE_ACTIVE_PING_GRAPH,
  CHANGE_ACTIVE_TOPOLOGY,
  CHANGE_ACTIVE_ITEM_GRAPHIC_TOPOLOGY,
  SOLVE_PROBLEM,
} from "../actions/types";

export function activeMenuItemReducer(initialState = { activeItem: "/" }, action) {
  switch (action.type) {
    case CHANGE_ACTIVE_ITEM_HOME:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_LIVELIST:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_LOG:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_CONFIG:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_INVENTORY:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_PORTS:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_MEDIA:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_INTERFACE:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_NETWORK:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_PING_GRAPH:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_TOPOLOGY:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_GRAPHIC_TOPOLOGY:
      return action.payload.activeItem;
    default:
      return initialState;
  }
}

export function solveProblemReducer(initialState = { solve: false, problem: {} }, action) {
  switch (action.type) {
    case SOLVE_PROBLEM:
      return action.payload;
    default:
      return initialState;
  }
}